import { PortalProvider } from '@core/portal/portal.service';
import { Inject } from '@rxdi/core';
import { Component, property } from '@rxdi/lit-html';
import { html, LitElement } from '@rxdi/lit-html';

/**
 * @customElement rx-info
 */
@Component({
  selector: 'rx-info',
  template(this: InformationComponent) {
    return html`
      <slot></slot>
      <svg
        @mouseover=${() => {
          this.openPortal();
        }}
        @mouseout=${() => {
          this.closePortal();
        }}
        width="1.5em"
        height="1.5em"
        viewBox="0 0 18 18"
        fit=""
        preserveAspectRatio="xMidYMid meet"
        focusable="false"
        sandboxuid="0"
      >
        <path
          d="M9 16A7 7 0 1 0 9 2a7 7 0 0 0 0 14zm2.47-7.587a5.15 5.15 0 0 1-.548.61c-.206.195-.42.387-.64.578-.25.22-.418.37-.503.62-.09.26-.13.78-.14.78H8.08s.02-.48.06-.71a2.09 2.09 0 0 1 .19-.57c.09-.18.207-.34.348-.5A6.1 6.1 0 0 1 9.2 8.7c.156-.14.3-.268.436-.393s.253-.25.356-.382c.103-.13.184-.27.244-.42.06-.147.09-.312.09-.493 0-.4-.106-.702-.32-.913-.21-.21-.524-.32-.936-.32-.165 0-.93-.04-1.2.49-.075.142-.187.49-.187.68H6c.072-.598.178-.91.33-1.21.155-.308.366-.49.633-.7.267-.206.58-.33.94-.43.36-.105.75-.14 1.172-.14.463 0 .874.06 1.236.172.37.11.67.275.92.487.26.21.45.474.58.78.13.305.2.652.2 1.04 0 .28-.042.54-.14.78a2.81 2.81 0 0 1-.383.68zM8.997 14c-.32 0-.565-.094-.738-.284a1.006 1.006 0 0 1-.26-.704c0-.143.02-.276.06-.4a.923.923 0 0 1 .19-.32.868.868 0 0 1 .31-.215A1.11 1.11 0 0 1 8.99 12c.16 0 .3.026.426.077a.83.83 0 0 1 .312.215c.084.09.15.198.196.32.046.124.07.256.07.4 0 .28-.087.516-.26.704-.175.19-.42.284-.74.284z"
          fill-rule="evenodd"
          sandboxuid="0"
        ></path>
      </svg>
    `;
  },
})
export class InformationComponent extends LitElement {
  @Inject(PortalProvider)
  private portal: PortalProvider;

  @property({ type: String })
  text: string;

  OnUpdate() {
    const slot = this.shadowRoot.querySelector('slot');
    if (!this.text) {
      const nodes = slot.assignedNodes();
      this.text = nodes[0].textContent;
    }
    if (slot) {
      slot.remove();
    }
  }

  openPortal() {
    const rect = this.getBoundingClientRect();
    this.portal.attach(
      html`<div
        style="font-size: 12px; line-height: 18px; color: black; background: rgb(255, 255, 255); box-shadow: rgb(0 0 0 / 20%) 0px 1px 3px 0px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 2px 1px -1px; max-height: 384px; max-width: 384px; overflow-y: auto; padding: 16px;"
      >
        ${this.text}
      </div>`,
      {
        left: rect.x + window.scrollX + 10,
        top: rect.y + window.scrollY + 10,
      }
    );
  }

  closePortal() {
    this.portal.dettach();
  }
}
